import type { AriaAttributes } from 'react';

import classNames from 'classnames';

import styles from './VerticalNavigation.module.css';

import type { NavigationItem } from '../NavItem';
import { NavItem } from '../NavItem';
import { Text } from '../Text';

export interface VerticalNavigationProps extends AriaAttributes {
  className?: string;
  items: NavigationItem[];
}

/**
 * Render a sticky vertical navigation.
 *
 * @remarks
 * Use {@link Layout} to create a layout with a sticky sub navigation.
 * @beta
 * @see https://corgi-x.tfd.engineering/components/verticalnavigation
 */
export function VerticalNavigation(props: VerticalNavigationProps) {
  const { items: navItems, className, ...ariaAttributes } = props;

  return (
    <nav
      className={classNames(styles.root, className)}
      role="navigation"
      {...ariaAttributes}
    >
      <Text as="ul" bold>
        {navItems.map((item, i) => (
          <li key={i}>
            <NavItem {...item} />
          </li>
        ))}
      </Text>
    </nav>
  );
}
